import * as Types from '../Constants/AllConstants';

// Complete dashboard metrics
export const DashboardMetricsReducer = (
  state = { metrics: null },
  action
) => {
  switch (action.type) {
    case Types.DASHBOARD_METRICS_REQUEST:
      return { ...state, loading: true };
    case Types.DASHBOARD_METRICS_SUCCESS:
      return { loading: false, metrics: action.payload };
    case Types.DASHBOARD_METRICS_FAIL:
      return { loading: false, error: action.payload };
    case Types.DASHBOARD_METRICS_RESET:
      return { metrics: null };
    default:
      return state;
  }
};

// User metrics
export const DashboardUserMetricsReducer = (
  state = { userMetrics: null },
  action
) => {
  switch (action.type) {
    case Types.DASHBOARD_USER_METRICS_REQUEST:
      return { ...state, loading: true };
    case Types.DASHBOARD_USER_METRICS_SUCCESS:
      return { loading: false, userMetrics: action.payload };
    case Types.DASHBOARD_USER_METRICS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Email metrics
export const DashboardEmailMetricsReducer = (
  state = { emailMetrics: null },
  action
) => {
  switch (action.type) {
    case Types.DASHBOARD_EMAIL_METRICS_REQUEST:
      return { ...state, loading: true };
    case Types.DASHBOARD_EMAIL_METRICS_SUCCESS:
      return { loading: false, emailMetrics: action.payload };
    case Types.DASHBOARD_EMAIL_METRICS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// SMS metrics
export const DashboardSmsMetricsReducer = (
  state = { smsMetrics: null },
  action
) => {
  switch (action.type) {
    case Types.DASHBOARD_SMS_METRICS_REQUEST:
      return { ...state, loading: true };
    case Types.DASHBOARD_SMS_METRICS_SUCCESS:
      return { loading: false, smsMetrics: action.payload };
    case Types.DASHBOARD_SMS_METRICS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Revenue metrics
export const DashboardRevenueMetricsReducer = (
  state = { revenueMetrics: null },
  action
) => {
  switch (action.type) {
    case Types.DASHBOARD_REVENUE_METRICS_REQUEST:
      return { ...state, loading: true };
    case Types.DASHBOARD_REVENUE_METRICS_SUCCESS:
      return { loading: false, revenueMetrics: action.payload };
    case Types.DASHBOARD_REVENUE_METRICS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Performance metrics
export const DashboardPerformanceMetricsReducer = (
  state = { performanceMetrics: null },
  action
) => {
  switch (action.type) {
    case Types.DASHBOARD_PERFORMANCE_METRICS_REQUEST:
      return { ...state, loading: true };
    case Types.DASHBOARD_PERFORMANCE_METRICS_SUCCESS:
      return { loading: false, performanceMetrics: action.payload };
    case Types.DASHBOARD_PERFORMANCE_METRICS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};